export enum OrderEnum {
    MOVE_UP = "move_up",
    MOVE_DOWN = "move_down",
    MOVE_TOP = "move_to_top",
    MOVE_BOTTOM = "move_to_bottom",
}

